module.exports = __webpack_public_path__ + "img/launch_background.99fab286.png";